import React from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import Button from '../../Button';
import Paragraph from '../../Paragraph';

class Page2 extends React.PureComponent {
  componentDidMount() {
    if (window.pageYOffset > this.sectionRef.offsetTop) {
      window.scrollTo({ top: this.sectionRef.offsetTop, behavior: 'smooth' });
    }
  }

  render() {
    return (
      <fieldset className="page-2" ref={(sectionRef) => { this.sectionRef = sectionRef; }}>
        <h3 className="header-text smallest purple justifycentre"><span id="register2">Do you provide your consent to share your information with the LiveWell Dorset team – part of Public Health Dorset?</span></h3>
        <Paragraph>
          When you register with LiveWell Dorset, we ask you some questions about you and your health (how much you smoke, how active you are, how much you drink and how much you weigh). We store that information and use it to shape our service offer to you – such as the advice we give or the extra services we connect you to. The only people who will see this information will be those involved in the delivery of the service and management of the data. If you would like to use extra services (such as slimming clubs and pharmacies) we have to share this information with them. For us to be able to put you in touch with these services, we must have your consent to share that information with the service (we’ll ask for that later, when if you sign up for extra services).
        </Paragraph>
        <Paragraph>
          Before we can sign you up any further, we need to know:
        </Paragraph>
        <ul>
          <li>
            {"You're"} happy for your personal information to be shared with LiveWell Dorset.
          </li>
          <li>
            You understand what information may be shared and why, and that at times, our contact to you may be supported by technology partners, who have the same data protection standards and safeguards as we do
          </li>
          <li>
            You acknowledge that you can withdraw your consent at any time by informing LiveWell Dorset.
          </li>
          <li>
            You understand that if you do not give consent or withdraw consent then it could be difficult for us to connect you some of the services we offer.
          </li>
        </ul>
        <Paragraph>
          If you require any more information to help you make your choice then please contact the LiveWell Dorset team on 0800 840 1628.  All telephone conversations at LiveWell Dorset are recorded for quality and training purposes, and stored whilst you are registered as active within the service.
        </Paragraph>
        <Paragraph classes="button-groups" center>
          <Button classes={['color-button']} label="Yes I consent" onClick={this.props.onSubmit} />
          <Button classes={['underline-button']} label="No I do not consent" onClick={this.props.onNoConsent} />
        </Paragraph>
      </fieldset>
    );
  }
}

Page2.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onNoConsent: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'registrationPilot', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(Page2);



// WEBPACK FOOTER //
// ./src/Components/PilotRegister/FormPages/Page2.jsx